import React from "react";
import Hero from "../sections/Hero";
import RunningMarquee from "../sections/RunningMarquee";
import About from "../sections/About";
import Services from "../sections/Services";
import Impact from "../sections/Impact";
import WhoWeAre from "../sections/WhoWeAre";
import Projects from "../sections/Projects";
import Stats from "../sections/Stats";
import Team from "../sections/Team";
import Testimonials from "../sections/Testimonials";
import Blog from "../sections/Blog";
import Gallery from "../sections/Gallery";
import ContactSection from "../sections/ContactSection";

const Home = () => {
  return (
    <main>
      <Hero />
      <RunningMarquee />
      <About />
      <Services />
      <Impact />
      <WhoWeAre />
      <Projects />
      <Stats />
      <Team />
      <Testimonials />
      <RunningMarquee text="Honesty · Integrity · Quality · Trust" dark />
      <Blog />
      <Gallery />
      <ContactSection />
    </main>
  );
};

export default Home;
